import { countries } from 'country-data-list/src';
import * as yup from 'yup';

import Base from './Base';
import CaseCreationType from './CaseCreationType';
import CreatorType from './CreatorType';

export const CaseCreationTypes = [new CaseCreationType({ label: 'Manual Entry', value: 'manual_entry' }), new CaseCreationType({ label: 'Ambra GW', value: 'ambra_gw' })];

export const CreatorTypes = [new CreatorType({ label: 'Clinic Creators Only', value: 'own' }), new CreatorType({ label: 'Clinic and Mediphany Creators', value: 'both' })];

export const Colors = [{ value: '#388E3C' }, { value: '#2AAAE2' }, { value: '#C2185B' }, { value: '#F19100' }, { value: '#787FF6' }, { value: '#0D5CB8' }, { value: '#636363' }];

export const CountryList = countries.all.map((e) => ({ label: e.name, value: e.alpha2.toLowerCase() }));

const workspaceSchema = yup.object().shape({
  address: yup.string().required('Address is required'),
  adminEmail: yup.string().email('Invalid email format').required('Admin email is required'),
  adminName: yup.string().required('Admin name is required'),
  adminTelephone: yup.string().required('Admin telephone is required'),
  canRequestBeforePay: yup.string().required('Can request before pay is required'),
  caseCreationType: yup.string().oneOf(
    CaseCreationTypes.map((e) => e.value),
    'Invalid case creation type'
  ),
  clinicCode: yup.string().required('Invalid Workspace Name field'),
  contactNumber: yup.string().required('Contact number is required'),
  countryCode: yup.string().required('Country code is required'),
  creatorMode: yup.string().required('Creator mode is required'),
  creatorType: yup.string().oneOf(
    CreatorTypes.map((e) => e.value),
    'Invalid creator type'
  ),
  logoUrl: yup.string().required('Logo is required'),
  name: yup.string().min(3, 'Name must be at least 3 characters').max(32, 'Name must be at most 32 characters').required('Name is required'),
  namespaces: yup.array(),
  primaryColor: yup.string().oneOf(
    Colors.map((e) => e.value),
    'Invalid primary color'
  ),
  subdomain: yup
    .string()
    .matches(/^([a-z0-9][a-z0-9-]*[a-z0-9])$/i, 'Subdomain is not valid')
    .required('Subdomain is required'),
});

export const WorkspaceProductType = {
  LawFirm: { label: 'Law Firm', value: 'law-firm' },
  TechQA: { label: 'Tech QA', value: 'tech-qa' },
  whiteGlove: { label: 'White Glove', value: 'white-glove' },
  whiteGlovePlus: { label: 'White Glove+', value: 'white-glove-plus' },
};

export const WorkspaceMainFileType = {
  Any: { label: 'Any', value: 'any' },
  Dicom: { label: 'DICOM', value: 'dicom' },
};

export default class Workspace extends Base {
  static validateCreate(item, fields) {
    return super.validate(item, fields, workspaceSchema);
  }

  createdAt = new Date();
  name = '';
  id = null;
  caseCreationType = CaseCreationTypes[0].value;
  creatorType = CreatorTypes[0].value;
  address = '';
  countryCode = 'us';
  adminName = '';
  adminTelephone = '';
  adminEmail = '';
  logoUrl = '';
  primaryColor = Colors[0].value;
  updatedAt = new Date();
  subdomain = '';
  contactNumber = '';
  allowClinicUpload = 'not-allowed';
  productType = 'law-firm';
  clinicCode = '';
  namespaces = [];
  canRequestBeforePay = 'true';
  creatorMode = 'false';
  mainFileType = WorkspaceMainFileType.Dicom.value;
  radiologyReportRequired = 'true';
}
